import React from 'react';

import MuiTable from '@material-ui/core/Table';
import MuiTableBody from '@material-ui/core/TableBody';
import MuiTableHead from '@material-ui/core/TableHead';
import MuiTableRow from '@material-ui/core/TableRow';
import MuiTableCell from '@material-ui/core/TableCell';
import TableSelectColumn from '../../components/TableSelectColumn';
function ReportFilesTable({ children, onSelectAll, isAllSelected, isSomeSelected, columnFilters }) {
  return (
    <MuiTable
      style={{
        width: '100%',
        tableLayout: 'fixed',
      }}>
      <colgroup>
        <col style={{ width: '60px', minWidth: '60px', maxWidth: '60px' }} /> {/* Checkbox */}
        <col style={{ width: '140px', minWidth: '140px', maxWidth: '140px' }} /> {/* AWS Import Date */}
        <col style={{ width: '100px', minWidth: '100px', maxWidth: '100px' }} /> {/* DSP */}
        <col style={{ width: '280px', minWidth: '280px', maxWidth: '280px' }} /> {/* File URL */}
        <col style={{ width: '100px', minWidth: '100px', maxWidth: '100px' }} /> {/* Status */}
        {/* <col style={{ width: '100px', minWidth: '100px', maxWidth: '100px' }} /> */}
        {/* Rows column - commented for future analysis of column necessity */}
        {/* <col style={{ width: '140px', minWidth: '140px', maxWidth: '140px' }} /> */}
        {/* Total Value USD column - commented for future analysis of column necessity */}
        <col style={{ width: '100px', minWidth: '100px', maxWidth: '100px' }} /> {/* Actions */}
      </colgroup>
      <MuiTableHead>
        <MuiTableRow>
          <TableSelectColumn
            checked={isAllSelected}
            indeterminate={isSomeSelected}
            onChange={onSelectAll}
            tooltip="Select all files"
          />
          <MuiTableCell>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              AWS Import Date
              {columnFilters && columnFilters[0]}
            </div>
          </MuiTableCell>
          <MuiTableCell>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              DSP
              {columnFilters && columnFilters[1]}
            </div>
          </MuiTableCell>
          <MuiTableCell>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              File Url
              {columnFilters && columnFilters[2]}
            </div>
          </MuiTableCell>
          <MuiTableCell>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              Status
              {columnFilters && columnFilters[3]}
            </div>
          </MuiTableCell>
          {/* Rows column header - commented for future analysis of column necessity
          <MuiTableCell>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              Rows
              {columnFilters && columnFilters[4]}
            </div>
          </MuiTableCell> */}
          {/* Total Value column header - commented for future analysis of column necessity
          <MuiTableCell>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              Total Value
              {columnFilters && columnFilters[5]}
            </div>
          </MuiTableCell> */}
          <MuiTableCell></MuiTableCell>
        </MuiTableRow>
      </MuiTableHead>
      <MuiTableBody>{children}</MuiTableBody>
    </MuiTable>
  );
}

export default ReportFilesTable;
